import { apiFuns } from "sw-hic";
let { get, put, del, post, genStandard, exceptedReqs, download } = apiFuns;

console.log(exceptedReqs);
const api = {
  /*********** 住院记录 ***********/
  LisRecord: {
    ...genStandard("lisRecord", "/api/proxy", false),
  },
  ExportExcel: {
    getExcel: (para) => download(`/api/ip/export/test?month=${para}`, para),
  },
  Attachment: genStandard("attachment", "/api/store"),
};

export default api;